import React from 'react';
import banner from '../../../assets/header.png';
import OfferNewsMarque from './OfferNewsMarque';
import HeaderAuth from './HeaderAuth';

function Header({ page, imgSrc = banner }) {
  return (
    <div>
      <OfferNewsMarque />
      <section className='flex relative flex-col self-stretch w-full h-[38vh]'>
        <img
          loading='lazy'
          src={imgSrc}
          alt='Background'
          className='object-cover absolute inset-0 size-full brightness-75'
        />
        <div className='flex relative z-10 flex-col w-full'>
          <HeaderAuth color={'white'} page={page} />
        </div>
      </section>
    </div>
  );
}

export default Header;
